<template>
    <success_case_edit ></success_case_edit>
</template>
<script>
    import success_case_edit from "@/pages/shop/success_case_edit.vue";

    export default {
        name: "success_case_add",
        components: {
            success_case_edit
        },
    }
</script>